/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.applications.rpc.ApplicationsRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import {
  useQuery,
  useLazyQuery,
  useSuspenseQuery,
  QueryHookOptions,
  LazyQueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryResultTuple,
  QueryResult,
  UseSuspenseQueryResult,
} from 'data-fetching-client';
import * as References from './ApplicationsRpc';
import * as Queries from './ApplicationsRpc.dfc.new';
import type { AdditionalContextArgs } from './ApplicationsRpc.dfc.new';

type OverrideData<TTuple extends [any, any], TNewData> = [
  TTuple[0],
  Omit<TTuple[1], 'data'> & { data?: TNewData },
];

type LazyQueryResultTupleOverride<
  Response,
  Request extends Record<string, any>,
  DataOverride,
> = OverrideData<LazyQueryResultTuple<Response, Request>, DataOverride>;

type UseGetAppComponentIndexByAppIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppComponentIndexByAppIdResponseType>,
    References.GetAppComponentIndexByAppIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAppComponentIndexByAppId',
            References.GetAppComponentIndexByAppIdResponseType
          >
        : References.GetAppComponentIndexByAppIdResponseType)
    | undefined;
};

export function useGetAppComponentIndexByAppIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppComponentIndexByAppIdResponseType>,
    References.GetAppComponentIndexByAppIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppComponentIndexByAppIdQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppComponentIndexByAppId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppComponentIndexByAppIdQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppComponentIndexByAppIdQueryReturn<T>;
}

type UseGetAppComponentIndexByAppIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppComponentIndexByAppIdResponseType>,
    References.GetAppComponentIndexByAppIdRequestType,
    T extends true
      ? Record<
          'getAppComponentIndexByAppId',
          References.GetAppComponentIndexByAppIdResponseType
        >
      : References.GetAppComponentIndexByAppIdResponseType
  >;

export function useGetAppComponentIndexByAppIdLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppComponentIndexByAppIdResponseType>,
    References.GetAppComponentIndexByAppIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppComponentIndexByAppIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppComponentIndexByAppId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppComponentIndexByAppIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppComponentIndexByAppIdLazyQueryReturn<T>;
}

type UseGetAppComponentIndexByAppIdSuspenseQueryReturn<T extends boolean> =
  Omit<
    UseSuspenseQueryResult<
      Record<'result', References.GetAppComponentIndexByAppIdResponseType>,
      References.GetAppComponentIndexByAppIdRequestType
    >,
    'data'
  > & {
    data: T extends true
      ? Record<
          'getAppComponentIndexByAppId',
          References.GetAppComponentIndexByAppIdResponseType
        >
      : References.GetAppComponentIndexByAppIdResponseType;
  };

export function useGetAppComponentIndexByAppIdSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppComponentIndexByAppIdResponseType>,
    References.GetAppComponentIndexByAppIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppComponentIndexByAppIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APP_COMPONENT_INDEX_BY_APP_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppComponentIndexByAppId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppComponentIndexByAppIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppComponentIndexByAppIdSuspenseQueryReturn<T>;
}

type UseGetApplicationsForPortalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApplicationsForPortalResponseType>,
    References.GetApplicationsForPortalRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getApplicationsForPortal',
            References.GetApplicationsForPortalResponseType
          >
        : References.GetApplicationsForPortalResponseType)
    | undefined;
};

export function useGetApplicationsForPortalQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetApplicationsForPortalResponseType>,
    References.GetApplicationsForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationsForPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPLICATIONS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApplicationsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApplicationsForPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApplicationsForPortalQueryReturn<T>;
}

type UseGetApplicationsForPortalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApplicationsForPortalResponseType>,
    References.GetApplicationsForPortalRequestType,
    T extends true
      ? Record<
          'getApplicationsForPortal',
          References.GetApplicationsForPortalResponseType
        >
      : References.GetApplicationsForPortalResponseType
  >;

export function useGetApplicationsForPortalLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApplicationsForPortalResponseType>,
    References.GetApplicationsForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationsForPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPLICATIONS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApplicationsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApplicationsForPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApplicationsForPortalLazyQueryReturn<T>;
}

type UseGetApplicationsForPortalSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetApplicationsForPortalResponseType>,
    References.GetApplicationsForPortalRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getApplicationsForPortal',
        References.GetApplicationsForPortalResponseType
      >
    : References.GetApplicationsForPortalResponseType;
};

export function useGetApplicationsForPortalSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApplicationsForPortalResponseType>,
    References.GetApplicationsForPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationsForPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPLICATIONS_FOR_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApplicationsForPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApplicationsForPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApplicationsForPortalSuspenseQueryReturn<T>;
}

type UseGetApplicationsByProjectAndPortalQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetApplicationsByProjectAndPortalResponseType>,
    References.GetApplicationsByProjectAndPortalRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getApplicationsByProjectAndPortal',
            References.GetApplicationsByProjectAndPortalResponseType
          >
        : References.GetApplicationsByProjectAndPortalResponseType)
    | undefined;
};

export function useGetApplicationsByProjectAndPortalQuery<
  T extends boolean = false,
>(
  options?: QueryHookOptions<
    Record<'result', References.GetApplicationsByProjectAndPortalResponseType>,
    References.GetApplicationsByProjectAndPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationsByProjectAndPortalQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApplicationsByProjectAndPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApplicationsByProjectAndPortalQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApplicationsByProjectAndPortalQueryReturn<T>;
}

type UseGetApplicationsByProjectAndPortalLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetApplicationsByProjectAndPortalResponseType>,
    References.GetApplicationsByProjectAndPortalRequestType,
    T extends true
      ? Record<
          'getApplicationsByProjectAndPortal',
          References.GetApplicationsByProjectAndPortalResponseType
        >
      : References.GetApplicationsByProjectAndPortalResponseType
  >;

export function useGetApplicationsByProjectAndPortalLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetApplicationsByProjectAndPortalResponseType>,
    References.GetApplicationsByProjectAndPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationsByProjectAndPortalLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getApplicationsByProjectAndPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetApplicationsByProjectAndPortalLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetApplicationsByProjectAndPortalLazyQueryReturn<T>;
}

type UseGetApplicationsByProjectAndPortalSuspenseQueryReturn<
  T extends boolean,
> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetApplicationsByProjectAndPortalResponseType>,
    References.GetApplicationsByProjectAndPortalRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getApplicationsByProjectAndPortal',
        References.GetApplicationsByProjectAndPortalResponseType
      >
    : References.GetApplicationsByProjectAndPortalResponseType;
};

export function useGetApplicationsByProjectAndPortalSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetApplicationsByProjectAndPortalResponseType>,
    References.GetApplicationsByProjectAndPortalRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetApplicationsByProjectAndPortalSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APPLICATIONS_BY_PROJECT_AND_PORTAL_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getApplicationsByProjectAndPortal: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetApplicationsByProjectAndPortalSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetApplicationsByProjectAndPortalSuspenseQueryReturn<T>;
}

type UseGetByClientIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByClientIdResponseType>,
    References.GetByClientIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getByClientId', References.GetByClientIdResponseType>
        : References.GetByClientIdResponseType)
    | undefined;
};

export function useGetByClientIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByClientIdResponseType>,
    References.GetByClientIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByClientIdQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_BY_CLIENT_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByClientId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByClientIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByClientIdQueryReturn<T>;
}

type UseGetByClientIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByClientIdResponseType>,
    References.GetByClientIdRequestType,
    T extends true
      ? Record<'getByClientId', References.GetByClientIdResponseType>
      : References.GetByClientIdResponseType
  >;

export function useGetByClientIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByClientIdResponseType>,
    References.GetByClientIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByClientIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_CLIENT_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByClientId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByClientIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByClientIdLazyQueryReturn<T>;
}

type UseGetByClientIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByClientIdResponseType>,
    References.GetByClientIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getByClientId', References.GetByClientIdResponseType>
    : References.GetByClientIdResponseType;
};

export function useGetByClientIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByClientIdResponseType>,
    References.GetByClientIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByClientIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_BY_CLIENT_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getByClientId: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByClientIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByClientIdSuspenseQueryReturn<T>;
}

type UseGetByIdQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getById', References.GetByIdResponseType>
        : References.GetByIdResponseType)
    | undefined;
};

export function useGetByIdQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_BY_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetByIdQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByIdQueryReturn<T>;
}

type UseGetByIdLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType,
    T extends true
      ? Record<'getById', References.GetByIdResponseType>
      : References.GetByIdResponseType
  >;

export function useGetByIdLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_ID_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByIdLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByIdLazyQueryReturn<T>;
}

type UseGetByIdSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getById', References.GetByIdResponseType>
    : References.GetByIdResponseType;
};

export function useGetByIdSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByIdResponseType>,
    References.GetByIdRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_BY_ID_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getById: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByIdSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByIdSuspenseQueryReturn<T>;
}

type UseGetAppByComponentKeyQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAppByComponentKeyResponseType>,
    References.GetAppByComponentKeyRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAppByComponentKey',
            References.GetAppByComponentKeyResponseType
          >
        : References.GetAppByComponentKeyResponseType)
    | undefined;
};

export function useGetAppByComponentKeyQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAppByComponentKeyResponseType>,
    References.GetAppByComponentKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppByComponentKeyQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_APP_BY_COMPONENT_KEY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppByComponentKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppByComponentKeyQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppByComponentKeyQueryReturn<T>;
}

type UseGetAppByComponentKeyLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAppByComponentKeyResponseType>,
    References.GetAppByComponentKeyRequestType,
    T extends true
      ? Record<
          'getAppByComponentKey',
          References.GetAppByComponentKeyResponseType
        >
      : References.GetAppByComponentKeyResponseType
  >;

export function useGetAppByComponentKeyLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAppByComponentKeyResponseType>,
    References.GetAppByComponentKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppByComponentKeyLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_APP_BY_COMPONENT_KEY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAppByComponentKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAppByComponentKeyLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAppByComponentKeyLazyQueryReturn<T>;
}

type UseGetAppByComponentKeySuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAppByComponentKeyResponseType>,
    References.GetAppByComponentKeyRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAppByComponentKey',
        References.GetAppByComponentKeyResponseType
      >
    : References.GetAppByComponentKeyResponseType;
};

export function useGetAppByComponentKeySuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAppByComponentKeyResponseType>,
    References.GetAppByComponentKeyRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAppByComponentKeySuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_APP_BY_COMPONENT_KEY_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAppByComponentKey: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAppByComponentKeySuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAppByComponentKeySuspenseQueryReturn<T>;
}

type UseGetByIdsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<'getByIds', References.GetByIdsResponseType>
        : References.GetByIdsResponseType)
    | undefined;
};

export function useGetByIdsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdsQueryReturn<T> {
  const { data, ...rest } = useQuery(Queries.GET_BY_IDS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return { data: legacyFormatData, ...rest } as UseGetByIdsQueryReturn<T>;
  }
  return { data: data?.result, ...rest } as UseGetByIdsQueryReturn<T>;
}

type UseGetByIdsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType,
    T extends true
      ? Record<'getByIds', References.GetByIdsResponseType>
      : References.GetByIdsResponseType
  >;

export function useGetByIdsLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_BY_IDS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetByIdsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetByIdsLazyQueryReturn<T>;
}

type UseGetByIdsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<'getByIds', References.GetByIdsResponseType>
    : References.GetByIdsResponseType;
};

export function useGetByIdsSuspenseQuery<T extends boolean = false>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetByIdsResponseType>,
    References.GetByIdsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetByIdsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(Queries.GET_BY_IDS_QUERY, options);

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getByIds: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetByIdsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetByIdsSuspenseQueryReturn<T>;
}

type UseGetAiConnectorCatalogQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetAiConnectorCatalogResponseType>,
    References.GetAiConnectorCatalogRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getAiConnectorCatalog',
            References.GetAiConnectorCatalogResponseType
          >
        : References.GetAiConnectorCatalogResponseType)
    | undefined;
};

export function useGetAiConnectorCatalogQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetAiConnectorCatalogResponseType>,
    References.GetAiConnectorCatalogRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiConnectorCatalogQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_AI_CONNECTOR_CATALOG_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAiConnectorCatalog: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAiConnectorCatalogQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAiConnectorCatalogQueryReturn<T>;
}

type UseGetAiConnectorCatalogLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetAiConnectorCatalogResponseType>,
    References.GetAiConnectorCatalogRequestType,
    T extends true
      ? Record<
          'getAiConnectorCatalog',
          References.GetAiConnectorCatalogResponseType
        >
      : References.GetAiConnectorCatalogResponseType
  >;

export function useGetAiConnectorCatalogLazyQuery<T extends boolean = false>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetAiConnectorCatalogResponseType>,
    References.GetAiConnectorCatalogRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiConnectorCatalogLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_AI_CONNECTOR_CATALOG_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getAiConnectorCatalog: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetAiConnectorCatalogLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetAiConnectorCatalogLazyQueryReturn<T>;
}

type UseGetAiConnectorCatalogSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetAiConnectorCatalogResponseType>,
    References.GetAiConnectorCatalogRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getAiConnectorCatalog',
        References.GetAiConnectorCatalogResponseType
      >
    : References.GetAiConnectorCatalogResponseType;
};

export function useGetAiConnectorCatalogSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetAiConnectorCatalogResponseType>,
    References.GetAiConnectorCatalogRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetAiConnectorCatalogSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_AI_CONNECTOR_CATALOG_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getAiConnectorCatalog: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetAiConnectorCatalogSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetAiConnectorCatalogSuspenseQueryReturn<T>;
}

type UseGetLocalisedAppPermissionsQueryReturn<T extends boolean> = Omit<
  QueryResult<
    Record<'result', References.GetLocalisedAppPermissionsResponseType>,
    References.GetLocalisedAppPermissionsRequestType
  >,
  'data'
> & {
  data:
    | (T extends true
        ? Record<
            'getLocalisedAppPermissions',
            References.GetLocalisedAppPermissionsResponseType
          >
        : References.GetLocalisedAppPermissionsResponseType)
    | undefined;
};

export function useGetLocalisedAppPermissionsQuery<T extends boolean = false>(
  options?: QueryHookOptions<
    Record<'result', References.GetLocalisedAppPermissionsResponseType>,
    References.GetLocalisedAppPermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetLocalisedAppPermissionsQueryReturn<T> {
  const { data, ...rest } = useQuery(
    Queries.GET_LOCALISED_APP_PERMISSIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getLocalisedAppPermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetLocalisedAppPermissionsQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetLocalisedAppPermissionsQueryReturn<T>;
}

type UseGetLocalisedAppPermissionsLazyQueryReturn<T extends boolean> =
  LazyQueryResultTupleOverride<
    Record<'result', References.GetLocalisedAppPermissionsResponseType>,
    References.GetLocalisedAppPermissionsRequestType,
    T extends true
      ? Record<
          'getLocalisedAppPermissions',
          References.GetLocalisedAppPermissionsResponseType
        >
      : References.GetLocalisedAppPermissionsResponseType
  >;

export function useGetLocalisedAppPermissionsLazyQuery<
  T extends boolean = false,
>(
  options?: LazyQueryHookOptions<
    Record<'result', References.GetLocalisedAppPermissionsResponseType>,
    References.GetLocalisedAppPermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetLocalisedAppPermissionsLazyQueryReturn<T> {
  const [getter, { data, ...rest }] = useLazyQuery(
    Queries.GET_LOCALISED_APP_PERMISSIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      data && options?.useLegacyFieldNameMode
        ? {
            getLocalisedAppPermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (data && options?.useLegacyFieldNameMode) {
    return [
      getter,
      { data: legacyFormatData, ...rest },
    ] as UseGetLocalisedAppPermissionsLazyQueryReturn<T>;
  }
  return [
    getter,
    { data: data?.result, ...rest },
  ] as UseGetLocalisedAppPermissionsLazyQueryReturn<T>;
}

type UseGetLocalisedAppPermissionsSuspenseQueryReturn<T extends boolean> = Omit<
  UseSuspenseQueryResult<
    Record<'result', References.GetLocalisedAppPermissionsResponseType>,
    References.GetLocalisedAppPermissionsRequestType
  >,
  'data'
> & {
  data: T extends true
    ? Record<
        'getLocalisedAppPermissions',
        References.GetLocalisedAppPermissionsResponseType
      >
    : References.GetLocalisedAppPermissionsResponseType;
};

export function useGetLocalisedAppPermissionsSuspenseQuery<
  T extends boolean = false,
>(
  options?: SuspenseQueryHookOptions<
    Record<'result', References.GetLocalisedAppPermissionsResponseType>,
    References.GetLocalisedAppPermissionsRequestType
  > & { context?: AdditionalContextArgs } & { useLegacyFieldNameMode?: T }
): UseGetLocalisedAppPermissionsSuspenseQueryReturn<T> {
  const { data, ...rest } = useSuspenseQuery(
    Queries.GET_LOCALISED_APP_PERMISSIONS_QUERY,
    options
  );

  const legacyFormatData = useMemo(
    () =>
      options?.useLegacyFieldNameMode
        ? {
            getLocalisedAppPermissions: data?.result,
          }
        : undefined,
    [data, options?.useLegacyFieldNameMode]
  );

  if (options?.useLegacyFieldNameMode) {
    return {
      data: legacyFormatData,
      ...rest,
    } as UseGetLocalisedAppPermissionsSuspenseQueryReturn<T>;
  }
  return {
    data: data?.result,
    ...rest,
  } as UseGetLocalisedAppPermissionsSuspenseQueryReturn<T>;
}
